@if (logo()) {
  <img
    [ngSrc]="logo() ?? ''"
    [class]="imageHeight()"
    [priority]="logoPriority()"
    [loaderParams]="{ transformations: imageOptimisation() }"
    alt=""
    class="!relative !w-auto object-contain"
    fill
    aria-hidden="true"
    disableOptimizedSrcset="true"
    rmaBrokenImage />
}
